// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__81_jW","big":"Title_big__RfSxe","medium":"Title_medium__3tNXJ"};